import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import DeleteModel from "./deleteModel";
import useDialogState, { LoaderBlack } from "../../hook";
import CategoryService from "../../services/category.service";
import { notifyError, notifySuccess } from "../../hook/notification";
import { useNavigate } from "react-router-dom";
import "react-toggle/style.css";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Toggle from "react-toggle";
import AddImageService from "../../services/addSingleImage.service";
import Parallax4DImageService from "../../services/parallax4D.service";
import liveWallpaperService from "../../services/livewallpaper.service";
import wallpaper3DService from "../../services/3Dwallpaper.service";
import AddHDRImageService from "../../services/hdr.service";
import CollectionService from "../../services/collection.service";
import AddLiveClockService from "../../services/liveclock.service";

const CommonTable = ({
  setPageSize,
  setPageNumber,
  pageSize,
  tableData,
  getAllData,
  totalCount,
  load,
  handleChangeOptoion,
  countList,
  onSort,
}) => {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const [loading, setLoading] = useState(false);
  const [openTag, setOpenTag] = useState(false);
  const [CategoryData, setCategoryData] = useState("");
  const [rowData, setRowData] = useState({});

  const handleChangeAllPage = (item) => {
    setPageSize(item);
  };

  const onPageChange = (count) => {
    setPageNumber(count);
  };

  const options = [
    { label: "All", value: "All" },
    { label: "4D", value: "FOURD" },
    { label: "4K", value: "FOURK" },
    { label: "Live", value: "LIVEWALLPAPER" },
    // { label: "3D", value: "THREED" },
    { label: "HDR", value: "HDR" },
    { label: "Live Clock", value: "LIVECLOCK" },
  ];

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const EditCategory = (row) => {
    navigate(`/add-categories`, { state: row });
  };

  const EditCollection = (row) => {
    navigate(`/add-collections`, { state: row });
  };

  const EditImage = (row) => {
    const liveClockId = row.imageId || row.id;
    const liveClockPath = liveClockId
      ? `/live-clock?id=${encodeURIComponent(liveClockId)}`
      : "/live-clock";

    if (row.clockSettingsId || row.foregroundImage) {
      navigate(liveClockPath, { state: row });
    } else if (row.imageType === "LIVEWALLPAPER") {
      navigate(`/wallpaper`, { state: row });
    } else if (row.imageType === "THREED") {
      navigate(`/3d-wallpaper`, { state: row });
    } else if (row.imageType === "FOURK") {
      navigate(`/add-images`, { state: row });
    } else if (row.imageType === "FOURD") {
      navigate(`/parallax`, { state: row });
    } else if (row.imageType === "HDR") {
      navigate(`/add-hdr-images`, { state: row });
    } else if (row.imageType === "LIVECLOCK") {
      navigate(liveClockPath, { state: row });
    }
  };

  const toggle = (row) => {
    // console.log("🚀 ~ toggle ~ row:", row);
    setCategoryData(row);
    setLoader();
  };

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagInputChange = (e) => {
    setTagInput(e.target.value);
  };

  const handleAddTag = () => {
    if (tagInput.trim() !== "") {
      if (tags === null || tags.length === 0) {
        setTags([tagInput.trim()]);
      } else {
        setTags([...tags, tagInput.trim()]);
      }
      setTagInput("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const changeSpecial = async (row) => {
    const {
      categoryId,
      collectionId,
      imageName,
      imageType,
      imageId,
      categoryphoto,
      multimediaType,
      tags,
      premium,
    } = row;
    // console.log("🚀 ~ changeSpecial ~ imageName:", row, imageName);
    try {
      const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      const fileData = new FormData();
      if (categoryId) {
        fileData.append("categoryId", categoryId);
      }
      if (collectionId) {
        fileData.append("collectionId", collectionId);
      }
      fileData.append("imageName", imageName);
      if (categoryphoto !== "" && imageType !== "THREED") {
        fileData.append("categoryphoto", emptyFile);
      }
      if (imageType === "THREED") {
        fileData.append("previewImage", emptyFile);
        fileData.append("layer1", emptyFile);
      }
      fileData.append("id", imageId);
      fileData.append("premium", !premium);
      fileData.append("tags", tags || "");
      if (imageType === "LIVEWALLPAPER") {
        fileData.append("multimediaType", multimediaType);
      }
      if (imageType === "FOURD") {
        fileData.append("images.layer1", emptyFile);
        fileData.append("images.layer2", emptyFile);
        fileData.append("images.layer3", emptyFile);
        fileData.append("images.depth1", emptyFile);
        fileData.append("images.depth2", emptyFile);
        fileData.append("images.depth3", emptyFile);
      }
      if (imageType === "HDR") {
        await AddHDRImageService.createImage(fileData);
      } else if (imageType === "FOURD") {
        await Parallax4DImageService.create4DParallaxImage(fileData);
      } else if (imageType === "THREED") {
        await wallpaper3DService.create3DWallpaper(fileData);
      } else if (imageType === "LIVEWALLPAPER") {
        await liveWallpaperService.createLiveImage(fileData);
      } else if (imageType === "LIVECLOCK") {
        await AddLiveClockService.updateClockWallpaper(imageId, fileData);
      } else {
        await AddImageService.createImage(fileData);
      }
      getAllData();
      notifySuccess("Premium update successfully");
    } catch (error) {
      // console.error("create error", error);
      notifyError("Something went wrong");
    }
  };

  const handleOpenTag = (row) => {
    setOpenTag(true);
    setTags(row.tags);
    setRowData(row);
  };

  const newTagSave = async () => {
    const {
      categoryId,
      imageName,
      imageId,
      imageType,
      categoryphoto,
      multimediaType,
      premium,
    } = rowData;
    try {
      const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      const fileData = new FormData();
      fileData.append("categoryId", categoryId);
      fileData.append("imageName", imageName);
      if (categoryphoto !== "") {
        if (imageType === "FOURD" || imageType === "THREED") {
          fileData.append("previewImage", emptyFile);
        } else {
          fileData.append("categoryphoto", emptyFile);
        }
      }
      if (imageType === "THREED") {
        fileData.append("layer1", emptyFile);
      }
      fileData.append("id", imageId);
      if (imageType === "LIVEWALLPAPER") {
        fileData.append("multimediaType", multimediaType);
      }
      if (imageType === "FOURD") {
        fileData.append("images.layer1", emptyFile);
        fileData.append("images.layer2", emptyFile);
        fileData.append("images.layer3", emptyFile);
        fileData.append("images.depth1", emptyFile);
        fileData.append("images.depth2", emptyFile);
        fileData.append("images.depth3", emptyFile);
      }
      fileData.append("premium", premium);
      fileData.append("tags", tags || "");
      if (imageType === "HDR") {
        await AddHDRImageService.createImage(fileData);
      } else if (imageType === "FOURD") {
        await Parallax4DImageService.create4DParallaxImage(fileData);
      } else if (imageType === "THREED") {
        await wallpaper3DService.create3DWallpaper(fileData);
      } else if (imageType === "LIVEWALLPAPER") {
        await liveWallpaperService.createLiveImage(fileData);
      } else if (imageType === "LIVECLOCK") {
        await AddLiveClockService.updateClockWallpaper(imageId, fileData);
      } else {
        await AddImageService.createImage(fileData);
      }
      setOpenTag(false);
      getAllData();
      setTags([]);
      setTagInput("");
      notifySuccess("Tags update successfully");
    } catch (error) {
      // console.error("create error", error);
      notifyError("Something went wrong");
    }
  };

  const columnsCategory = [
    {
      name: <b>IMAGE</b>,
      selector: (row, index) => (
        <div className="py-4 flex items-center">
          <div className="text-[16px] pe-2 font-semibold">{index + 1}.</div>
          <div className="h-20 w-60 overflow-hidden rounded-6">
            <img
              className="w-full h-full object-cover center"
              src={row.categoryBackgroundImage}
              alt="category"
            />
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>CATEGORY NAME</b>,
      selector: (row) => row.categoryName,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <div className="flex justify-center gap-2">
          <MdEdit
            onClick={() => EditCategory(row)}
            className="text-blue text-2xl cursor-pointer"
          />
          <MdDeleteOutline
            onClick={() => toggle(row)}
            className="text-red text-2xl cursor-pointer"
          />
        </div>
      ),
      sortable: true,
    },
  ];

  const columnsCollection = [
    {
      name: <b>IMAGE</b>,
      selector: (row, index) => (
        <div className="py-4 flex items-center">
          <div className="text-[16px] pe-2 font-semibold">{index + 1}.</div>
          <div className="w-[12rem] overflow-hidden rounded-6">
            <img
              className="w-full h-full object-contain center"
              src={row.previewurl}
              alt="category"
            />
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>Collection NAME</b>,
      selector: (row) => row.collectionName,
      sortable: true,
    },
    {
      name: <b>Display Mode</b>,
      selector: (row) =>
        options.find((option) => option.value === row.displayMode)?.label,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <div className="flex justify-center gap-2">
          <MdEdit
            onClick={() => EditCollection(row)}
            className="text-blue text-2xl cursor-pointer"
          />
          <MdDeleteOutline
            onClick={() => toggle(row)}
            className="text-red text-2xl cursor-pointer"
          />
        </div>
      ),
      sortable: true,
    },
  ];

  const columnSingleImages = [
    {
      name: <b>IMAGE</b>,
      selector: (row, index) => (
        <div className="py-4 flex items-center">
          {/* {console.log("row", row.imageType)} */}
          <div className="text-[16px] pe-2 font-semibold text-clip">
            {index + 1}.
          </div>
          <div className="h-[280px] w-36 overflow-hidden rounded-6">
            {row.imageType === "LIVEWALLPAPER" || row.imageType === "THREED" ? (
              <video
                className="h-[280px] w-36 object-cover center"
                autoPlay
                loop
                src={row.url}
              />
            ) : (
              <img
                className="h-[280px] w-36 object-cover center"
                src={row.url}
                alt="single"
              />
            )}
          </div>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: <b>NAME</b>,
      selector: (row) => row.imageName,
      sortable: true,
    },
    {
      name: <b>PREMIUM</b>,
      selector: (row) => (
        <Toggle
          checked={row.isPremium ? true : false}
          onClick={() => changeSpecial(row)}
        />
      ),
    },
    {
      name: <b>TAGS</b>,
      selector: (row) => (
        <>
          <div
            className="text-22 text-blue font-semibold cursor-pointer"
            onClick={() => handleOpenTag(row)}
          >
            #
          </div>{" "}
          <div title={row.tags} className="flex">
            {Array.isArray(row.tags) ? row.tags.filter(Boolean).join(",") : ""}
          </div>
        </>
      ),
    },
    {
      name: <b>TOTAL DOWNLOADS</b>,
      selector: (row) => row.downloadCount,
      sortable: true,
      sortField: "downloadCount",
    },
    {
      name: <b>FAVOURITES</b>,
      selector: (row) => (row.favorites ? row.favorites : 0),
      sortable: true,
      sortField: "favorites",
    },
    {
      name: <b>CATEGORY</b>,
      selector: (row) => (
        <div className="text-black font-semibold">{row.categoryName}</div>
      ),
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <div className="flex justify-center gap-2">
          <MdEdit
            onClick={() => EditImage(row)}
            className="text-blue text-2xl cursor-pointer"
          />
          <MdDeleteOutline
            onClick={() => toggle(row)}
            className="text-red text-2xl cursor-pointer"
          />
        </div>
      ),
    },
  ];
  const DeleteCategory = async () => {
    // setLoading(true)
    if (location.includes("images")) {
      await CategoryService.DeleteImagesList(CategoryData.imageId);
      notifySuccess("Image delete successfully");
    } else if (location.includes("collections")) {
      await CollectionService.DeleteCollection(CategoryData.id);
      notifySuccess("Collection delete successfully");
    } else {
      await CategoryService.DeleteCategory(CategoryData.id);
      notifySuccess("Category delete successfully");
    }
    // setLoading(false)
    unSetLoader();
    getAllData();
  };

  return (
    <div className="mb-5" style={{ position: "relative" }}>
      {location.includes("images") && (
        <div className="max-w-[250px] cursor-pointer ms-auto">
          <Dropdown
            options={options}
            placeholder="All"
            onChange={(e) => handleChangeOptoion(e)}
            className="cursor-pointer"
          />
          ;
        </div>
      )}

      <DataTable
        data={tableData}
        columns={
          location.includes("categories")
            ? columnsCategory
            : location.includes("collections")
              ? columnsCollection
              : columnSingleImages
        }
        noHeader
        persistTableHead
        pagination
        highlightOnHover
        center={true}
        paginationServer
        paginationTotalRows={totalCount}
        paginationRowsPerPageOptions={[10, 50, 500]}
        paginationPerPage={pageSize}
        onChangeRowsPerPage={(page) => {
          handleChangeAllPage(page, 1);
        }}
        progressPending={load}
        progressComponent={
          <div style={{ padding: 15 }}>
            <LoaderBlack />
          </div>
        }
        onChangePage={onPageChange}
        onSort={(column, direction) => {
          if (column.sortField) {
            onSort(column.sortField);
          }
        }}
        customStyles={{
          headCells: {
            style: {
              backgroundColor: "#0D47A1",
              color: "white",
            },
          },
        }}
      />
      {!location.includes("categories") &&
        !location.includes("collections") && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: "5%",
              textAlign: "center",
            }}
          >
            <div>Total Wallpaper : {countList.totalCount}</div>
            <div>
              <span>4K : {countList["4K"]}</span>
              <span style={{ marginLeft: "10px" }}>4D : {countList["4D"]}</span>
              <span style={{ marginLeft: "10px" }}>
                Live : {countList.Live}
              </span>
              <span style={{ marginLeft: "10px" }}>3D : {countList["3D"]}</span>
              <span style={{ marginLeft: "10px" }}>
                HDR : {countList["HDR"]}
              </span>
            </div>
          </div>
        )}
      {loader && (
        <DeleteModel
          loader={loading}
          unSetLoader={unSetLoader}
          DeleteCategory={DeleteCategory}
        />
      )}

      {openTag && (
        <div className="fixed inset-0 bg-[black]/60 z-[999] overflow-y-auto">
          <div
            className="flex items-center justify-center min-h-screen px-4"
            // onClick={() => setOpen(false)}
          >
            <div className="bg-white overflow-hidden rounded-6 p-5 lg:p-7 max-w-[500px] w-full min-w-[350px]">
              <h1 className="font-medium mb-5">Update Title</h1>
              <div className="flex flex-col gap-2 mb-7">
                <label className="text-sm font-medium">Tag Title</label>
                <input
                  className="bg-white w-full py-1.5 px-3 rounded-6 focus:outline-none border border-blue"
                  type="text"
                  placeholder="Enter Tag Name..."
                  value={tagInput}
                  onChange={handleTagInputChange}
                />
                <button
                  className="bg-blue w-full p-2 rounded-6 text-white font-medium"
                  onClick={handleAddTag}
                >
                  Update Tag
                </button>
              </div>
              {tags &&
                tags.length > 0 &&
                tags.map((tag, index) => (
                  <div key={index} className="border rounded-6 mb-1">
                    <div className="grid grid-cols-4 items-center border-b px-3 py-1.5">
                      <div className="col-span-3">
                        <span className="text-sm">{tag}</span>
                      </div>
                      <div className="col-span-1 flex justify-end border-l">
                        <button
                          className="bg-red/80 text-white text-sm font-medium rounded-6 py-1.5 px-2.5"
                          onClick={() => handleRemoveTag(tag)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              <div className="flex justify-end gap-4 items-center mt-7">
                <button
                  onClick={() => (
                    setOpenTag(false),
                    setTags([]),
                    setTagInput("")
                  )}
                  className="border border-red/80 text-red/80 font-medium rounded-6 py-1.5 px-2.5 w-full"
                >
                  Cancel
                </button>
                <button
                  onClick={() => newTagSave()}
                  className="bg-blue text-white font-medium rounded-6 py-1.5 px-2.5 w-full"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommonTable;
